import { useTranslation } from "react-i18next";

export default function WatWijHerstellen() {
  const { t } = useTranslation("inbraakschade-reparatie");
  const rows = t("watWijHerstellen.rows", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  const images = [
    "/img/13-damaged-white-front-door.jpg",
    "/img/20-shattered-double-glazing-window.jpg",
    "/img/11-damaged-pvc-window-frame.jpg",
    "/img/15-drilled-forced-brass-cylinder.jpg",
    "/img/17-sliding-patio-door-damaged.jpg",
    "/img/09-back-door-damaged-lock.jpg",
  ];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("watWijHerstellen.h2")}
        </h2>
        <div className="flex flex-col gap-12 md:gap-16">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex flex-col md:flex-row items-center gap-8 md:gap-12 ${
                i % 2 === 1 ? "md:flex-row-reverse" : ""
              }`}
            >
              <div className="flex-1 w-full">
                <div className="relative aspect-[4/3] rounded-2xl overflow-hidden">
                  <img
                    src={images[i]}
                    alt={row.title}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-3">
                  {row.title}
                </h3>
                <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed">
                  {row.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}